"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.form.knowledge.show': '显示知识条目',
    'avatar.form.knowledge.label': '知识库条目',
    'avatar.form.knowledge.search_placeholder': '搜索知识条目...',
    'avatar.form.knowledge.add': '添加新知识',
    'avatar.form.knowledge.fullscan': '全文档扫描',
    'avatar.form.title.edit': '编辑头像',
    'avatar.form.title.add': '添加头像',
    'avatar.form.back': '返回',
    'avatar.form.name.label': '名称',
    'avatar.form.name.placeholder': '头像名称',
    'avatar.form.gender.label': '性别',
    'avatar.form.gender.placeholder': '选择性别',
    'avatar.form.gender.none': '无',
    'avatar.form.gender.male': '男性',
    'avatar.form.gender.female': '女性',
    'avatar.form.age.label': '年龄',
    'avatar.form.age.placeholder': '年龄',
    'avatar.form.voice.label': '语音',
    'avatar.form.voice.placeholder': '-- 选择语音 --',
    'avatar.form.voice.male': '男性语音',
    'avatar.form.voice.female': '女性语音',
    'avatar.form.logo.label': '头像图片',
    'avatar.form.logo.placeholder': '发送头像图片',
    'avatar.form.instructionFile.label': '指令文件',
    'avatar.form.instructionFile.placeholder': '上传指令文件',
    'avatar.form.instructions.title': '指令',
    'avatar.form.instructions.description': '管理指导头像行为的指令条目。每个条目必须附带文件，也可以包含备注和提示词。',
    'avatar.form.error.instruction_file_required': '每个指令条目都必须附带文件。',
    'avatar.form.instructions.add': '添加指令',
    'avatar.form.instructions.empty': '暂无指令条目。点击“添加指令”创建一个。',
    'avatar.form.instructions.untitled': '未命名层',
    'avatar.form.instructions.layer.label': '层',
    'avatar.form.instructions.layer.placeholder': '输入层名称',
    'avatar.form.instructions.notes.label': '备注',
    'avatar.form.instructions.notes.placeholder': '输入指令备注',
    'avatar.form.instructions.prompt.label': '指令提示词',
    'avatar.form.instructions.prompt.placeholder': '输入指令提示词',
    'avatar.form.instructions.file.label': '指令文件',
    'avatar.form.instructions.isPublic.label': '公开（包含在 Webhook 中）',
    'avatar.form.instructions.file.placeholder': '上传指令文件',
    'avatar.form.instructions.files.label': '指令文件',
    'avatar.form.instructions.files.placeholder': '上传指令文件',
    'avatar.form.instructions.versions.title': '版本历史',
    'avatar.form.instructions.versions.show': '显示版本历史',
    'avatar.form.instructions.versions.hide': '隐藏版本历史',
    'avatar.form.instructions.versions.empty': '没有可用的历史版本。',
    'avatar.form.instructions.versions.restore': '恢复',
    'avatar.form.instructions.versions.restore_confirm': '确定要恢复此版本吗？当前更改将被覆盖。',
    'avatar.form.description.label': '描述',
    'avatar.form.description.placeholder': '描述',
    'avatar.form.model.label': '模型',
    'avatar.form.model.placeholder': '选择模型',
    'avatar.form.knowledge.placeholder': '选择知识条目',
    'avatar.form.submit.update': '更新头像',
    'avatar.form.submit.create': '创建头像',
    'avatar.form.submit.saveAndReturn.update': '保存头像并返回列表',
    'avatar.form.submit.saveAndReturn.create': '创建头像并返回列表',
    'avatar.form.tab.configuration': '配置',
    'avatar.form.tab.knowledge': '知识库',
    'avatar.form.tab.instructions': '指令文件',
    'avatar.form.tab.tools': '工具',
    'avatar.form.tab.webhooks': 'Webhooks',
    'avatar.form.tab.lexicon': '词汇表',
    'avatar.form.tab.apiTools': 'API 工具',
    'avatar.form.timed.label': '启用基于时间的可用性',
    'avatar.form.timed.help': '限制此化身的可用时间',
    'avatar.form.startTime.label': '可用开始时间',
    'avatar.form.startTime.placeholder': '选择开始日期',
    'avatar.form.endTime.label': '可用结束时间',
    'avatar.form.endTime.placeholder': '选择结束日期',
    'avatar.form.webhooks.config.title': 'Webhook配置',
    'avatar.form.webhooks.config.description': '为所有webhook端点配置授权设置',
    'avatar.form.webhooks.config.authHeader.label': '授权头',
    'avatar.form.webhooks.config.authHeader.placeholder': '例如：Authorization',
    'avatar.form.webhooks.config.authKey.label': '授权密钥',
    'avatar.form.webhooks.config.authKey.placeholder': 'Bearer令牌或API密钥',
    'avatar.form.webhooks.definitions.title': 'Webhook定义',
    'avatar.form.webhooks.definitions.add': '添加Webhook',
    'avatar.form.webhooks.definitions.empty': '没有配置的webhook定义。点击"添加Webhook"来创建一个。',
    'avatar.form.webhooks.definitions.untitled': '未命名的Webhook',
    'avatar.form.webhooks.definitions.name.label': 'Webhook名称',
    'avatar.form.webhooks.definitions.name.placeholder': '输入webhook名称',
    'avatar.form.webhooks.definitions.address.label': 'Webhook URL',
    'avatar.form.webhooks.definitions.address.placeholder': 'https://your-endpoint.com/webhook',
    'avatar.form.webhooks.definitions.eventType.label': '事件类型',
    'avatar.form.webhooks.definitions.cronInterval.label': 'Cron间隔',
    'avatar.form.webhooks.definitions.cronInterval.placeholder': '*/30 * * * *',
    'avatar.form.webhooks.definitions.cronInterval.help': 'Cron表达式（例如：*/30 * * * * = 每30分钟）',
    'avatar.form.webhooks.definitions.cronEnabled.label': '启用Cron',
    'avatar.form.webhooks.definitions.active.label': '活跃',
    'avatar.form.webhooks.definitions.authEnabled.label': '启用授权',
    'avatar.form.webhooks.definitions.authHeader.label': '授权头',
    'avatar.form.webhooks.definitions.authHeader.placeholder': '例如：Authorization',
    'avatar.form.webhooks.definitions.authKey.label': '授权密钥',
    'avatar.form.webhooks.definitions.authKey.placeholder': 'Bearer令牌或API密钥',
    'avatar.form.webhooks.payload.title': '载荷示例',
    'avatar.form.webhooks.payload.subtitle': '此webhook事件类型的示例JSON载荷',
    'avatar.form.webhooks.payload.description': '这是将发送到您的webhook端点的JSON数据结构。',
    'avatar.form.lexicon.title': '词汇表条目',
    'avatar.form.lexicon.add': '添加条目',
    'avatar.form.lexicon.empty': '未配置词汇表条目。点击"添加条目"创建一个。',
    'avatar.form.lexicon.untitled': '无标题条目',
    'avatar.form.lexicon.hidden': '隐藏',
    'avatar.form.lexicon.label.label': '标签',
    'avatar.form.lexicon.label.placeholder': '输入术语或单词',
    'avatar.form.lexicon.value.label': '定义',
    'avatar.form.lexicon.value.placeholder': '输入定义或解释',
    'avatar.form.lexicon.hidden.label': '隐藏',
    'avatar.form.lexicon.hidden.help': '启用后，此条目对用户不可见，但会被化身用于理解',
    'avatar.form.apiTools.title': 'API 工具',
    'avatar.form.apiTools.description': '配置AI在对话中可以调用的外部API端点',
    'avatar.form.apiTools.enabled.label': '启用API工具',
    'avatar.form.apiTools.enabled.help': '允许化身调用外部API端点',
    'avatar.form.apiTools.list.title': 'API端点',
    'avatar.form.apiTools.add': '添加端点',
    'avatar.form.apiTools.empty': '未配置API端点。点击"添加端点"创建一个。',
    'avatar.form.apiTools.untitled': '未命名端点',
    'avatar.form.apiTools.name.label': '名称',
    'avatar.form.apiTools.name.placeholder': '输入端点名称',
    'avatar.form.apiTools.endpoint.label': '端点URL',
    'avatar.form.apiTools.endpoint.placeholder': 'https://api.example.com/endpoint',
    'avatar.form.apiTools.method.label': '方法',
    'avatar.form.apiTools.description.label': '描述',
    'avatar.form.apiTools.description.placeholder': '描述此API端点的功能',
    'avatar.form.apiTools.description.help': '描述帮助AI理解何时以及如何使用此端点',
    'avatar.form.apiTools.authEnabled.label': '启用授权',
    'avatar.form.apiTools.authHeader.label': '授权头',
    'avatar.form.apiTools.authHeader.placeholder': '例如 Authorization',
    'avatar.form.apiTools.authKey.label': '授权密钥',
    'avatar.form.apiTools.authKey.placeholder': 'Bearer令牌或API密钥',
    'avatar.form.apiTools.authKey.toggle': '显示/隐藏密钥',
    'avatar.form.apiTools.payloadFields.title': '负载字段',
    'avatar.form.apiTools.payloadFields.add': '添加字段',
    'avatar.form.apiTools.payloadFields.description': '定义AI调用此端点时将填充的字段',
    'avatar.form.apiTools.payloadFields.empty': '未定义负载字段。点击"添加字段"创建一个。',
    'avatar.form.apiTools.payloadFields.name.label': '字段名称',
    'avatar.form.apiTools.payloadFields.name.placeholder': '例如 query',
    'avatar.form.apiTools.payloadFields.desc.label': '字段描述',
    'avatar.form.apiTools.payloadFields.desc.placeholder': '描述此字段的用途，以便AI知道如何填充',
    'avatar.form.apiTools.payloadFields.type.label': '类型',
    'avatar.form.apiTools.payloadFields.optional.label': '可选',
    'avatar.form.tools.title': '可用工具',
    'avatar.form.tools.description': '选择此头像在对话中可以使用的工具',
    'avatar.form.error.load_failed': '加载头像失败',
    'avatar.form.error.model_required': '模型是必需的',
    'avatar.form.error.action_failed': '操作失败',
    'avatar.form.error.general_error': '发生错误',
    'avatar.form.action.updated': '已更新',
    'avatar.form.action.created': '已创建',
    'avatar.form.action.update': '更新',
    'avatar.form.action.create': '创建',
    'avatar.form.success.updated': '头像更新成功',
    'avatar.form.success.action_completed': '头像操作成功完成',
};
